import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import navigateToURL from 'lib/navigateToURL';
import {agentHomepageUrl} from 'llm/routes/UrlUtils';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import {AgentMembersTable} from './MembersTable';
import {Member, MemberInfo} from './OrganizationConstants';

export default function OrganizationAgentMembersTab({
  organization,
  organizationAgentMembers,
  isCurrentUserMember,
  canManageRoles,
  userIdToMemberInfo,
}: {
  organization: {id: string};
  organizationAgentMembers: Array<Member> | null;
  isCurrentUserMember: boolean;
  canManageRoles: boolean;
  userIdToMemberInfo: {[userId: string]: MemberInfo} | null;
}): JSX.Element {
  if (!organizationAgentMembers || !userIdToMemberInfo) {
    return <CenteredHorizontalThrobber />;
  }

  return (
    <AgentMembersTable
      groupId={organization.id}
      groupType={ModelTypeConstants.ORGANIZATION}
      canManageRoles={canManageRoles}
      members={organizationAgentMembers}
      shouldShowMemberInfo={isCurrentUserMember || canManageRoles}
      userIdToMemberInfo={userIdToMemberInfo}
      onRowClick={({id}) => {
        navigateToURL(agentHomepageUrl(id));
      }}
    />
  );
}
